import React, { useState } from "react";

import DashboardContext from "./DashboardContext";

const DashboardProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    Boolean(window.sessionStorage.getItem("auth")) || false
  );
  const [userEmail, setUserEmail] = useState(
    window.sessionStorage.getItem("email") || ""
  );

  function signOut() {
    window.sessionStorage.clear();
    setIsAuthenticated(false);
  }

  return (
    <DashboardContext.Provider
      value={{
        setIsAuthenticated,
        isAuthenticated,
        setUserEmail,
        userEmail,
        signOut,
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

export default DashboardProvider;
